<template>
  <div class="main-content">
    <div class="section__content section__content--p30">
      <div class="container-fluid job-info-container">
        <v-card class="p-b-40 p-t-30 p-l-30 p-r-30 m-b-40">
          <div class="el-loading-mask" v-if="loading">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg>
            </div>
          </div>
          <!-- Name -->
          <div class="row">
            <div class="col-md-12 header">
              <h3 class="title-7 p-b-10">
                <v-btn
                  text
                  icon
                  class="m-0"
                  @click="$router.back()">
                  <i class="zmdi zmdi-long-arrow-left"></i>
                </v-btn>
                {{ distribution.name }}
                <v-btn
                  text
                  icon
                  class="m-0"
                  @click.stop="editCD()">
                  <i class="zmdi zmdi-edit grey--text" style="font-size: 1.4rem;"></i>
                </v-btn>
              </h3>
            </div>
          </div>
          <v-divider></v-divider>
          <!-- Status and general Info -->
          <div class="row">
            <div class="col-md-2">
              <div class="info-title">
                <i class="zmdi zmdi-file-text p-r-5"></i>
                ID
              </div>
              <div>
                {{ distribution.id }}
              </div>
            </div>
            <div class="col-md-5">
              <div class="info-title">
                <i class="zmdi zmdi-calendar p-r-10"></i> {{ text('created') }}
              </div>
              <div>
                {{ formatTime(distribution.createTime) }}
              </div>
            </div>
            <div class="col-md-5">
              <div class="info-title">
                <i class="zmdi zmdi-calendar p-r-10"></i> {{ text('updated') }}
              </div>
              <div>
                {{ formatTime(distribution.updateTime) }}
              </div>
            </div>
          </div>
          <v-divider></v-divider>
          <div class="row">
            <div class="col-md-12">
              <!-- CDN -->
              <table class="job-output m-t-50">
                <tbody>
                <tr>
                  <td class="column-title">
                    CDN:
                  </td>
                  <td>
                    {{ distribution.cdn.name || 'N/A' }}
                    <span v-if="distribution.cdn.state && !distribution.cdn.disabled">
                      ({{ text('state') }} = {{ distribution.cdn.state }})
                    </span>
                    <span v-if="distribution.cdn.id && distribution.cdn.disabled">
                      ({{ text('state') }} = {{ text('disabled') }})
                    </span>
                    <v-btn
                      v-if="distribution.cdn.id"
                      text
                      icon
                      class="m-0"
                      @click.stop="editCDN(distribution.cdn.id)">
                      <i class="zmdi zmdi-edit grey--text"></i>
                    </v-btn>
                  </td>
                </tr>
                <tr v-if="distribution.cdn.whitelist">
                  <td>
                    {{ text('whitlist_list') }}:
                  </td>
                  <td>
                    <ul>
                      <li v-for="wl of distribution.cdn.whitelist" :key="wl">
                        {{ wl }}
                      </li>
                    </ul>
                  </td>
                </tr>
                </tbody>
              </table>

              <!-- Channels -->
              <table class="job-output m-t-50">
                <tbody>
                <tr>
                  <td class="column-title">
                    {{ text('channel_list') }}:
                  </td>
                  <td>
                    <span class="m-r-15">{{ distribution.channels.length }}</span>
                    <v-btn class="m-0"
                           outline
                           small
                           @click="csvExport">
                      <i class="zmdi zmdi-download p-r-10"></i>{{ text('export_csv_btn') }}
                    </v-btn>
                  </td>
                </tr>
                <tr v-if="userIP && !ipWhitelisted">
                  <td colspan="2" class="text-left">
                    <v-alert
                      type="warning"
                      :value="true"
                      color="deep-orange lighten-1">
                      {{ text('distrib_warn_text1') }} {{ userIP }} {{ text('distrib_warn_text2') }}
                    </v-alert>
                  </td>
                </tr>
                <template v-for="channel of distribution.channels">
                  <tr v-for="url of channel.urls" :key="url">
                    <td>
                      {{ channel.name }}
                    </td>
                    <td>
                      <a :href="url" target="_blank">{{ url }}</a>
                      <i @click="handleCopy(url)" class="zmdi zmdi-copy m-l-10 pointer"></i>
                      <a :href="createExtURL(url)"
                         v-if="(url.endsWith('m3u8') || url.endsWith('mpd')) && ipWhitelisted"
                         target="_blank">
                        <i class="fa fa-play-circle m-l-15"></i>
                      </a>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </div>
        </v-card>

        <!-- Stat -->
        <v-card class="m-t-10 m-b-50 p-b-30 p-t-30 p-l-30 p-r-30" v-if="stat.length">
          <div class="row">
            <div class="col-md-6">
          <v-card-text>
            <v-sheet color="rgba(0, 0, 0, .12)">
              <v-sparkline
                :value="plotValue"
                height="100"
                padding="24"
                stroke-linecap="round"
                smooth
              >
                <template v-slot:label="item">
                  {{ item.value }} GB
                </template>
              </v-sparkline>
            </v-sheet>
          </v-card-text>

          <v-card-text>
            <div class="display-1 font-weight-thin">CDN Traffic Last 7 days</div>
          </v-card-text>
            </div>
            <div class="col-md-6 p-t-15">
              <table class="table-cdn-traffic">
                <thead>
                <tr>
                  <td>Date</td>
                  <td>Traffic</td>
                  <td>Cached</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(stat, i) of this.stat" :key="i">
                  <td>{{ stat.date }}</td>
                  <td>{{ formatBytes(stat.transferred, 2) }}</td>
                  <td>{{ formatBytes(stat.cached, 2) }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { setClipboard } from '@/helpers/utils';
import { processChannelDistribution } from '@/store/converters';

function IPnumber(IPaddress) {
  const ip = IPaddress.match(/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/);
  if (ip) {
    // eslint-disable-next-line no-bitwise
    return (+ip[1] << 24) + (+ip[2] << 16) + (+ip[3] << 8) + (+ip[4]);
  }
  return null;
}

function IPmask(maskSize) {
  // eslint-disable-next-line no-bitwise
  return -1 << (32 - maskSize);
}

export default {
  created() {
    const cdId = this.$route.params.id;
    this.$store.commit('setPageLoader');
    this.$store.dispatch('channelDistribs/getChannelDistrib', cdId)
      .then((cd) => {
        this.distribution = processChannelDistribution(cd);
        this.checkIP();
        this.getStat();
      })
      .catch((errorMsg) => {
        this.$toasted.error(errorMsg, {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 10000,
        });
        this.$router.push({ name: 'DistributionListPage' });
      })
      .finally(() => this.$store.commit('resolvePageLoader'));
  },
  data() {
    return {
      distribution: {
        cdn: {},
        channels: [],
      },
      userIP: '',
      ipWhitelisted: false,
      stat: [],
      plotValue: [],
    };
  },
  computed: {
    loading() {
      return this.$store.getters.isDataLoaded;
    },
    dict() {
      return this.$store.getters.dictionary;
    },
  },
  methods: {
    formatTime(time) {
      return moment(time).format('DD/MM/YYYY HH:mm');
    },
    handleCopy(text) {
      setClipboard(text);
      this.$toasted.info(this.text('copied'), {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 1000,
      });
    },
    formatLogDate(timestamp) {
      return moment.unix(timestamp).format('DD/MM/YYYY HH:mm');
    },
    editCD() {
      this.$router.push({
        name: 'DistributionEditPage',
        params: {
          id: this.distribution.id,
        },
      });
    },
    createExtURL(url) {
      const link = url.replace(/^http:\/\//, 'https://');
      if (url.endsWith('mpd')) {
        return `https://shaka-player-demo.appspot.com/demo/#asset=${link}`;
      }
      return `https://hls-js.netlify.com/demo/?src=${escape(link)}`;
    },
    csvExport() {
      let csvContent = 'data:text/csv;charset=utf-8,';
      const rows = [];
      for (let i = 0; i < this.distribution.channels.length; i += 1) {
        const ch = this.distribution.channels[i];
        for (let j = 0; j < ch.urls.length; j += 1) {
          rows.push(`${ch.name.replace(' ', '')};${ch.urls[j]}`);
        }
      }
      csvContent += rows
        .join('\n')
        .replace(/\(|\)/gm, '').replace(' ', '');

      const data = encodeURI(csvContent);
      const link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', `${this.distribution.name}.csv`);
      link.click();
    },
    checkIP() {
      this.$store.dispatch('checkIP')
        .then((result) => {
          const parts = result.split('\n');
          for (let i = 0; i < parts.length; i += 1) {
            if (parts[i].startsWith('ip')) {
              this.userIP = parts[i].substr(3);
              break;
            }
          }
          if (this.distribution.cdn.whitelist
            && this.distribution.cdn.whitelist.length
            && this.userIP) {
            for (let i = 0; i < this.distribution.cdn.whitelist.length; i += 1) {
              const wlParts = this.distribution.cdn.whitelist[i].split('/');
              // eslint-disable-next-line no-bitwise,eqeqeq
              if ((IPnumber(wlParts[0]) & IPmask(wlParts[1])) == IPnumber(this.userIP)) {
                this.ipWhitelisted = true;
                break;
              }
            }
          } else {
            this.ipWhitelisted = true;
          }
        })
        .catch((errorMsg) => {
          console.log(errorMsg);
        });
    },
    editCDN(id) {
      this.$router.push({
        name: 'EndpointEditPage',
        params: {
          id,
        },
      });
    },
    getStat() {
      if (this.distribution.cdn.id && moment(this.distribution.createTime).isSameOrBefore(moment().subtract(3, 'days'), 'day')) {
        this.$store.dispatch('getUsageForTheLastWeek', this.distribution.cdn.id)
          .then((response) => {
            this.stat = response;
            for (let j = 0; j < response.length; j += 1) {
              this.plotValue.push(Math.round(response[j].transferred / 1024 / 1024 / 1024));
            }
          })
          .catch((errorMsg) => {
            /*            this.$toasted.error(errorMsg, {
              theme: 'toasted-primary',
              position: 'top-center',
              duration: 10000,
            }); */
          });
      }
    },
    formatBytes(bytes, decimals = 0) {
      if (bytes === 0) return '0 KB';
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },
    text(code) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.dict.hasOwnProperty(code)) {
        return this.dict[code];
      }
      return code;
    },
  },
};
</script>
